import queryString from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';

import {
  CheckoutLayout,
  Logo,
  NeedHelp,
  NeedHelpNoCustomer
} from 'common/components/layout';
import { getMessage } from 'common/helpers/miscHelper';
import {
  getReservation,
  getReservationByEmailReservationNumber
} from 'redux/reservations/actions';

import CustomerDetails from './components/CustomerDetails';
import Notes from './components/Notes';
import ReservationDetail from './components/ReservationDetail';
import ReservationSummaryReceipt from './components/ReservationSummaryReceipt';

class Receipt extends Component {
  componentDidMount() {
    const { props } = this;
    if (props.match.params.reservationId) {
      props.getReservation(props.match.params.reservationId);
    } else {
      const { location } = this.props;
      const queryObj = queryString.parse(location.search);
      props.getReservationByEmailReservationNumber(
        queryObj.email,
        queryObj.reservationNumber
      );
    }
  }

  render() {
    const { reservations, settings, customer, location } = this.props;
    const queryObj = queryString.parse(location.search);
    const { email } = queryObj;
    const { currentReservationId } = this.props;
    if (!settings.data || !reservations.data || !currentReservationId) {
      return (
        <CheckoutLayout title="Reservation Receipt" loading>
          &nbsp;
        </CheckoutLayout>
      );
    }
    const reservation = reservations.data[currentReservationId];
    return (
      <CheckoutLayout title="Reservation Receipt">
        <div className="c7-checkout">
          <ReservationSummaryReceipt
            reservation={reservation}
            settings={settings}
          />
          <div className="c7-checkout__main c7-checkout__main--wide">
            <div className="c7-checkout__header">
              <Logo />
              <h2>
                <span>Reservation No. {reservation.reservationNumber}</span>
                Thank you {customer.data && customer.data.firstName}!
              </h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: getMessage('Reservation Receipt Message', settings)
                }}
              />
            </div>
            <div className="c7-account__order-detail__customer-details">
              <ReservationDetail
                reservation={reservation}
                settings={settings}
              />
              <CustomerDetails reservation={reservation} />
              <Notes reservation={reservation} />
              {customer.data && (
                <NeedHelp
                  type="Reservation"
                  reservationNumber={reservation.reservationNumber}
                  customer={customer.data}
                  hasContinueShopping
                  settings={settings}
                />
              )}
              {!customer.data && (
                <NeedHelpNoCustomer
                  type="Reservation"
                  reservation={reservation}
                  email={email}
                  hasContinueShopping
                  settings={settings}
                />
              )}
            </div>
          </div>
        </div>
      </CheckoutLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  reservations: state.reservation,
  currentReservationId: state.reservation.currentReservationId,
  settings: state.setting,
  customer: state.customer
});

export default connect(mapStateToProps, {
  getReservation,
  getReservationByEmailReservationNumber
})(Receipt);
